import { render, staticRenderFns } from "./tabelaGuiasVista.vue?vue&type=template&id=4600ef7a"
import script from "./tabelaGuiasVista.vue?vue&type=script&lang=js"
export * from "./tabelaGuiasVista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports